import { FLAG_KEYS } from './flagKeys';
import { useFeatureFlag } from './useFeatureFlag';

export const useRedesign = (): boolean => useFeatureFlag(FLAG_KEYS.REDESIGN);
